module.exports = __webpack_public_path__ + "img/pc.e774f6b9.png";